import { WIRTransverseRoles } from 'types/wellGuardian';

export const getAllWirRoles = () =>
  Object.keys(WIRTransverseRoles).filter(role => role !== WIRTransverseRoles.WIR_DEVELOPER);
